import { __awaiter } from "tslib";
import { InsuranceType, useSaveOrderServicesMutation } from '@websky/graphql';
import { IINFieldKeyFactory } from './utils';
import { fillOrder } from '../Checkout/store/order/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useToggleable } from '../hooks';
import { getOrder as getRootOrder } from '../Checkout/store/order/selectors';
export const usePassengersToConfirmIIN = (setNextStep) => {
    var _a;
    const dispatch = useDispatch();
    const order = useSelector(getRootOrder);
    const [saveOrderServices, saveOrderServicesResult] = useSaveOrderServicesMutation();
    const { isOpen: isInsuranceModalOpen, open: openInsuranceModal, close: closeInsuranceModal } = useToggleable(false);
    const insurances = order.additionalServices.insurances;
    const allowedPassengers = (_a = insurances === null || insurances === void 0 ? void 0 : insurances.insurancePrograms.find(program => program.type === InsuranceType.AlphaInsurance)) === null || _a === void 0 ? void 0 : _a.allowedPassengers;
    const isPassengerIinNeeded = insurances === null || insurances === void 0 ? void 0 : insurances.travellerExtraValues.some(extraValue => extraValue.needKzIinDocument);
    const isAlphaInsuranceSelected = insurances === null || insurances === void 0 ? void 0 : insurances.selectedInsurances.find(selectedInsurance => selectedInsurance.insuranceProgram.type === InsuranceType.AlphaInsurance);
    const filteredPassengers = order.travellers.filter(traveller => allowedPassengers === null || allowedPassengers === void 0 ? void 0 : allowedPassengers.includes(Number(traveller.id)));
    const passengersToConfirmIIN = !!isAlphaInsuranceSelected && isPassengerIinNeeded && !!filteredPassengers.length ? filteredPassengers : [];
    const isNeededToConfirmIIN = !!passengersToConfirmIIN.length;
    const saveInsuranceAndUpdateOrder = (values) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const selectedPrograms = (_b = insurances === null || insurances === void 0 ? void 0 : insurances.selectedInsurances) === null || _b === void 0 ? void 0 : _b.map(selectedInsurance => selectedInsurance.insuranceProgram.code);
        const programsByTravellers = filteredPassengers.map(traveller => {
            const travellerIINKey = IINFieldKeyFactory(traveller.id);
            return {
                travellerId: traveller.id,
                programCodes: selectedPrograms,
                travellerDocumentNumber: values[travellerIINKey]
            };
        });
        try {
            const { data } = yield saveOrderServices({
                variables: {
                    params: {
                        id: order.id,
                        insurances: [
                            {
                                insuranceType: InsuranceType.AlphaInsurance,
                                selectedPrograms,
                                selectedProgramsByTravellers: programsByTravellers
                            }
                        ]
                    }
                }
            });
            if (data === null || data === void 0 ? void 0 : data.SaveOrderServices) {
                dispatch(fillOrder(data.SaveOrderServices));
                closeInsuranceModal();
                setNextStep();
            }
        }
        catch (error) {
            return error['graphQLErrors'][0].debugMessage;
        }
    });
    return {
        passengersToConfirmIIN,
        isNeededToConfirmIIN,
        isInsuranceModalOpen,
        openInsuranceModal,
        closeInsuranceModal,
        isSaveOrderServicesLoading: saveOrderServicesResult.loading,
        saveInsuranceAndUpdateOrder
    };
};
